// Registry that maps chartId → the function that opens that chart's table-view dropdown.
// ChartTableView registers on mount and unregisters on unmount.
// WidgetRenderer calls openTableMenu() — no-op if the chart is not in table mode.

type OpenFn = (pos: { x: number; y: number }) => void;
const registry = new Map<string, OpenFn>();

export function registerTableMenu(chartId: string, fn: OpenFn) {
  registry.set(chartId, fn);
}

export function unregisterTableMenu(chartId: string) {
  registry.delete(chartId);
}

export function openTableMenu(chartId: string, pos: { x: number; y: number }): boolean {
  const fn = registry.get(chartId);
  if (fn) { fn(pos); return true; }
  return false;
}
